import { Box, Grid, Toolbar } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useAppUI } from 'src/context/AppUIProvider/useAppUI';
import { useStaticFlags } from 'src/common/hooks/useStaticFlags/useStaticFlags';
import { StaticFlags } from 'src/common/hooks/useStaticFlags/StaticFlagsHook.types';
import DownloadBanner from 'src/components/DownloadBanner';
import HeaderAlert from 'src/components/HeaderAlert';

const LayoutHeader = ({ children }: PropsWithChildren) => {
  const { isMobile, statusBar } = useAppUI();
  const { [StaticFlags.EnableDownloadBanner]: enableDownloadBanner } =
    useStaticFlags();

  return (
    <Box
      sx={{
        pb: 0.5,
        pt: isMobile && statusBar?.visible ? 4 : isMobile ? 1.5 : 0,
        height: 'fit-content',
        justifyContent: { xs: 'flex-end', md: undefined },
      }}
      color="inherit"
      zIndex={(theme) => theme.zIndex.appBar}
      bgcolor={'background.paper'}
    >
      {enableDownloadBanner && <DownloadBanner />}
      <Toolbar sx={{ px: isMobile ? 0 : undefined }}>
        <Grid
          container
          width="100%"
          rowSpacing={1}
          alignItems="center"
          position="relative"
          justifyContent="space-between"
        >
          {children}
        </Grid>
      </Toolbar>
      <Box mt={1}></Box>
      <HeaderAlert />
    </Box>
  );
};

LayoutHeader.displayName = 'LayoutHeader';

export default LayoutHeader;
